import { render } from "./RotationDamage.vue?vue&type=template&id=318c1632&scoped=true&ts=true"
import script from "./RotationDamage.vue?vue&type=script&lang=ts"
export * from "./RotationDamage.vue?vue&type=script&lang=ts"

import "./RotationDamage.vue?vue&type=style&index=0&id=318c1632&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-318c1632"]])

export default __exports__